import { writeCookie } from '@zapier/cookies';
import isProduction from './isProduction';

const setCookie = (
  id: string,
  value: string,
  maxAge: number,
  path: string = '/'
) => {
  if (!isProduction()) {
    // Consider switching to `writeCookie` from `@zapier/cookies`.
    // eslint-disable-next-line no-console
    console.warn('@zapier/common-utils `setCookie` is deprecated.');
  }
  try {
    writeCookie(id, value, {
      // Cookies are categorized as `essential` for backwards compatibility,
      // but devs should use `writeCookie` from `@zapier/cookies` with
      // the correct `category`.
      category: 'essential',
      maxAge,
      path,
    });
  } catch (e) {
    console.error('Unable to set cookie', {
      id,
    });
  }
};

export default setCookie;
